export const PARENT_NOTIFICATION_SETTINGS = [
  {
    setting: 'Raise Me updates & tips',
    topic: 'updatesAndTips',
    text: "Don't miss the chance to hear updates on how to best utilize Raise Me on your child's path to college success.",
  },
  {
    setting: 'Followed college updates & alerts',
    topic: 'followedCollegeUpdatesAndAlerts',
    text: 'By connecting with your student’s account, you will now receive notifications and important reminders from colleges your student is following.',
  },
];
